import React from "react";
import Header from "./Header";
import BottomNav from "./BottomNav";
import { useLocation } from "react-router-dom";

/**
 * The mobile-app-like container. Centered on desktop with max width 560px,
 * shadow on the sides to simulate a smartphone silhouette.
 */
export default function AppShell({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) return <>{children}</>;
  return (
    <div className="min-h-screen w-full flex justify-center bg-ivory-100 paper-texture">
      <div
        data-testid="app-shell"
        className="relative w-full max-w-[560px] min-h-screen bg-ivory-50 shadow-phone overflow-x-hidden"
      >
        <Header />
        {/* key={pathname} re-mounts the wrapper on every route change,
            re-running the CSS-only entrance animation. Zero JS overhead. */}
        <main key={loc.pathname} className="pb-32 route-transition">
          {children}
        </main>
        <BottomNav />
      </div>
    </div>
  );
}
